import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4cc3a518&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4cc3a518&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc3a518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc3a518')) {
      api.createRecord('4cc3a518', component.options)
    } else {
      api.reload('4cc3a518', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4cc3a518&scoped=true", function () {
      api.rerender('4cc3a518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/report/biReport/index.vue"
export default component.exports